import React from 'react';
import { Form, FormItemProps as AntdFormItemProps } from 'antd';
import { Rule } from 'antd/lib/form';

interface InputFormProps extends AntdFormItemProps {
  label?: string;
  name: string;
  placeholder?: string;
  rules?: Rule[];
  component: React.ReactNode;
  dependencies?: string[];
  valuePropName?: string;
}

const InputForm: React.FC<InputFormProps> = ({
  label,
  name,
  placeholder,
  rules,
  component,
  dependencies,
  valuePropName,
  ...rest
}) => {
  return (
    <Form.Item
      className={`custom-label !pt-1 `}
      label={label}
      name={name}
      rules={rules}
      dependencies={dependencies}
      valuePropName={valuePropName}
      {...rest}
    >
      <div className="input-container">
        {React.cloneElement(component as React.ReactElement, { placeholder })}
      </div>
    </Form.Item>
  );
};

export default InputForm;
